// extracted by css-extract-rspack-plugin
export default {"usageTagInUse":"ohcH9tWK8nArytJn","usageTagUnused":"wCVp1OOQQBsxCK7o"};